import { ref } from 'vue';
import ReCaptchaProvider from '@/Services/ReCaptcha/ReCaptchaProvider';

export function useRecaptcha(action) {
    const provider = new ReCaptchaProvider();
    const isCaptchaEnabled = ref(false);

    const initRecaptcha = async () => {
        isCaptchaEnabled.value = await provider.initAsync();
    };

    const getRecaptchaToken = () => provider.getTokenAsync(action);

    return { isCaptchaEnabled, initRecaptcha, getRecaptchaToken };
}
